import common from './common.js'


export default [
    ...common
];
